<template>
  <main>
    <LoadingState v-if="loading && slides.length === 0" />
    <OnboardingSteps
      v-else
      :steps="slides"
    />
    <Chat type="small" />
  </main>
</template>

<script>
import OnboardingSteps from '@/sections/onboarding/OnboardingSteps'
import LoadingState from '@/components/loading-state/LoadingState'

export default {
  name: 'Onboarding',
  components: {
    OnboardingSteps,
    LoadingState
  },
  computed: {
    loading () {
      return this.$store.state.onboarding.loading
    },
    slides () {
      console.log(this.$store.state.onboarding);
      return this.$store.state.onboarding.slides
    }
  },
  mounted () {
    this.$store.dispatch('userprofile/onboardingCompleted')
  },
  created () {
    this.$store.dispatch('onboarding/fetchSlides')
  }
}
</script>
